<template>
  <div>
    <template v-if="!isEdit">
      <v-layout wrap align-center>
        <v-flex xs6 v-if="computedShippingDate">
          วันที่ต้องการจัดส่ง :
          <span class="primary--text">{{ computedShippingDate }}</span>
        </v-flex>
        <v-flex xs5 v-if="shippingTime">
          เวลา:
          <span class="primary--text">{{ shippingTime }}</span>
        </v-flex>
        <v-flex xs1>
          <v-btn flat fab small color="primary" class="ma-0" @click="isEdit = true">
            <v-icon>edit</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
    <template v-else>
      <v-layout wrap>
        <v-flex xs6 class="pa-1">
          วันที่ต้องการจัดส่ง
          <DatepickerCustomDialog v-model="input.shipping_date">
            <template v-slot="{ computedDate }">
              <v-text-field
                class="custom-datepicker-input"
                outline
                name="startDate"
                placeholder="DD/MM/YYYY"
                readonly
                :value="computedDate"
                hide-details
                single-line
                prepend-inner-icon="event"
                style="color: #000"
              ></v-text-field>
            </template>
          </DatepickerCustomDialog>
        </v-flex>
        <v-flex xs6 class="pa-1" v-if="shippingTime">
          เวลา:
          <v-select
            v-model="input.shipping_time"
            :items="timeOptions"
            solo
            outline
            hide-details
            flat
            class="custom-select"
          ></v-select>
        </v-flex>
      </v-layout>
      <div class="text-xs-center">
        <v-btn outline small color="primary" @click="saveChange">
          <span class="fa fa-pencil-alt mr-2"></span> {{ $t('Save') }}
        </v-btn>
      </div>
    </template>
  </div>
</template>

<script>
import moment from 'moment'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import Multiselect from 'vue-multiselect'

export default {
  props: ['shippingDate', 'shippingTime'],
  components: {
    DatepickerCustomDialog,
    Multiselect
  },
  data() {
    return {
      isEdit: false,
      input: {
        shipping_date: moment(this.shippingDate).format('YYYY-MM-DD'),
        shipping_time: this.shippingTime
      },
      timeOptions: ['08.00-10.00', '10.00-12.00', '12.00-14.00', '14.00-16.00']
    }
  },
  computed: {
    computedShippingDate() {
      return this.shippingDate ? moment(this.shippingDate).format('DD/MM/YYYY') : ''
    }
  },
  methods: {
    saveChange() {
      this.isEdit = false
      this.$emit('edited', this.input)
    }
  }
}
</script>

<style lang="scss">
.custom-select.v-text-field--outline > .v-input__control > .v-input__slot {
  border-radius: 4px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/CityFreshShippingDate.vue